import { render, staticRenderFns } from "./BranchAccessibility.vue?vue&type=template&id=5f0f67d1&"
import script from "./BranchAccessibility.vue?vue&type=script&lang=js&"
export * from "./BranchAccessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports